import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { fetchFoldersChronologically } from '../../folders/state/actions';
import { StateType } from '../../state/reducers';

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  async onLoad() {
    await dispatch(fetchFoldersChronologically());
  },
});

export const Connect = connect(null, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
